import { render } from "./RecipeCommunity.vue?vue&type=template&id=4d366f04&scoped=true"
import script from "./RecipeCommunity.vue?vue&type=script&lang=js"
export * from "./RecipeCommunity.vue?vue&type=script&lang=js"

import "./RecipeCommunity.vue?vue&type=style&index=0&id=4d366f04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d366f04"]])

export default __exports__